// Działy wideo-instrukcji obsługi (przycisk „?” w nagłówku).
//
// Klucz działu = nazwa katalogu z filmem po stronie backendu (APP_MANUAL_ROOT/<klucz>/*.mp4,
// patrz App\Manual\ManualCatalog). Backend zwraca tylko działy dostępne dla zalogowanego
// użytkownika — tutaj jest wyłącznie powiązanie działu z ekranem, z którego otwarto instrukcję.
// Tytuł działu: klucz i18n `manual-section-<klucz>`.

// Nazwa trasy (router/index.js) => dział instrukcji opisujący ten ekran.
const SECTION_BY_ROUTE_NAME = {
  "password-expired": "04-resetowanie-hasla",
  home: "06-biezacy-pomiar",
  VehicleDetails: "06-biezacy-pomiar",
  archival: "07-archiwum",
  result: "07-archiwum",
  VehicleArchDetails: "07-archiwum",
  statistics: "08-statystyki",
  VmsView: "09-vms",
  UserManagementView: "10-zarzadzanie-uzytkownikami",
  UserActivityView: "11-historia-aktywnosci-uzytkownikow",
  RoleGroupManagementView: "12-grupy-rol",
  LocationManagementView: "13-zarzadzanie-lokalizacjami",
  TicketsView: "14-zgloszenia",
  "ticket-details": "14-zgloszenia",
  "ticket-edit": "14-zgloszenia",
  CalibrationView: "15-kalibracja",
  CalibrationDeviationView: "16-dewiacja-kalibracji",
  LocationStatusesView: "17-historia-statusow-lokalizacji",
  LocationStatusLatestView: "17-historia-statusow-lokalizacji",
  BlackListView: "18-czarne-listy",
  WhiteListView: "19-biale-listy",
  ContactView: "20-kontakty",
  preference: "21-preferencje",
};

// Zwraca klucz działu dla trasy albo null, gdy ekran nie ma własnego działu.
export function sectionForRoute(routeName) {
  return SECTION_BY_ROUTE_NAME[routeName] ?? null;
}

// Układa działy tak, by dział bieżącego ekranu był na górze; reszta w kolejności instrukcji.
export function orderSections(sections, currentKey) {
  const current = sections.filter((s) => s.key === currentKey);
  return [...current, ...sections.filter((s) => s.key !== currentKey)];
}
